import { render } from "./indexpage.vue?vue&type=template&id=756ec020"
import script from "./indexpage.vue?vue&type=script&lang=js"
export * from "./indexpage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__